<script setup lang="ts">
import {onMounted} from 'vue';
import {useCrmMetadataStore} from '@/stores';
import type {SectionDef} from '@/crm/spec/types';
import FieldRow from './FieldRow.vue';

interface IProps {
    section: SectionDef;
    record: any;
}

const props = defineProps<IProps>();

const metadataStore = useCrmMetadataStore();

onMounted(() => {
    metadataStore.ensureEntity(props.section.entity);
});
</script>

<template>
    <section class="field-section">
        <h2>{{ section.name }}</h2>
        <div class="field-grid">
            <template v-for="(def, i) in section.fields" :key="i">
                <FieldRow :record="record" :entity="section.entity" :def="def"/>
            </template>
        </div>
    </section>
</template>

<style scoped>
.field-section {
    background: var(--color-background-bright);
    border: 1px solid var(--color-border, rgba(0, 0, 0, 0.08));
    border-radius: 0.5rem;
    padding: 1rem 1.25rem 1.25rem;
    margin-bottom: 1rem;
}

.field-section h2 {
    margin: 0 0 0.75rem;
    font-size: var(--font-size-h2, 1.1rem);
    font-weight: 600;
    color: var(--color-text);
}

.field-grid {
    display: grid;
    grid-template-columns: max-content 1fr;
    column-gap: 1rem;
    row-gap: 0.45rem;
    align-items: baseline;
}

@media (max-width: 700px) {
    .field-grid {
        grid-template-columns: 1fr;
        row-gap: 0.2rem;
    }
}
</style>
